export default "__VITE_ASSET__sWyvlrzd__"